/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A2Inputs */

const en_cad_faq_a2 = /** @type {(inputs: Cad_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. CADCraft is an independent, clean-room project by the ArtCraft team that recreates the AutoCAD-style workflow. It is not affiliated with Autodesk. AutoCAD is a trademark of Autodesk, Inc.`)
};

/**
* | output |
* | --- |
* | "No. CADCraft is an independent, clean-room project by the ArtCraft team that recreates the AutoCAD-style workflow. It is not affiliated with Autodesk. AutoCA..." |
*
* @param {Cad_Faq_A2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a2 = /** @type {((inputs?: Cad_Faq_A2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a2(inputs)
});
export { cad_faq_a2 as "cad.faq.a2" }